/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IDobbiesFreeTrialCancellationData } from './dobbies-free-trial-cancellation.data';
import { IDobbiesFreeTrialCancellationProps } from './dobbies-free-trial-cancellation.props.autogenerated';

export interface IDobbiesFreeTrialCancellationViewProps extends IDobbiesFreeTrialCancellationProps<IDobbiesFreeTrialCancellationData> {}

/**
 *
 * DobbiesFreeTrialCancellation component
 * @extends {React.PureComponent<IDobbiesFreeTrialCancellationProps<IDobbiesFreeTrialCancellationData>>}
 */
class DobbiesFreeTrialCancellation extends React.PureComponent<IDobbiesFreeTrialCancellationProps<IDobbiesFreeTrialCancellationData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default DobbiesFreeTrialCancellation;
